import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {PageableModel} from "../../common/models/table";
import {NewDictionariesOwnedVehiclesModel, DictionariesOwnedVehiclesModel} from "../models/dictionariesOwnedVehicles";
import {AxiosPromise, AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";

export class DictionariesOwnedVehiclesService {
    private static basicUrl = apiUrls.dictionaries.ownedVehicles;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<DictionariesOwnedVehiclesModel>>> {
        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<DictionariesOwnedVehiclesModel>>(url);
    }

    public static async getOwnedVehicle(id: string): Promise<AxiosResponse<DictionariesOwnedVehiclesModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addOwnedVehicle(data: NewDictionariesOwnedVehiclesModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async removeOwnedVehicle(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async modifyOwnedVehicle(data: NewDictionariesOwnedVehiclesModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }
}
